import apiClient from '../apiClient';
import { POST_PAYMENT_METHOD_IN_COUNTRY_URL } from '../apiUrl';

const postPaymentMethodInCountryApi = data => {
  return apiClient.post(POST_PAYMENT_METHOD_IN_COUNTRY_URL, data);
};

export default postPaymentMethodInCountryApi;
